/**
 *
 * FilterCell
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap'
import { VirtualTable } from '@devexpress/dx-react-grid-bootstrap4';

// import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// import DateFnsUtils from '@date-io/date-fns';
// import es from 'date-fns/locale/es';
// import moment from 'moment/min/moment-with-locales';
// import DayPicker, { DateUtils } from 'react-day-picker';
// import 'react-day-picker/lib/style.css';

// moment.locale('es');

const FilterCell = ({ filter, onFilter, ...restProps }) => {
  // const [currentDate, setCurrentDate] = useState(null);
  // const [pickerOpen, setPickerOpen] = useState(false);
  // const [state, setState] = useState({
  //   from: undefined,
  //   to: undefined,
  // });

  // const { from, to } = state;

  // const changeDateFilter = date => {
  //   onFilter({
  //     value: date,
  //     day1: moment(date).format('YYYY/MM/DD'),
  //     day2: moment(date)
  //       .add(1, 'days')
  //       .format('YYYY/MM/DD'),
  //   });
  //   setCurrentDate(date);
  // };
  // const modifiers = { start: from, end: to };

  // const handleDayClick = day => {
  //   const range = DateUtils.addDayToRange(day, { from, to });
  //   setState(range);
  //   if (range.from && range.to) {
  //     setPickerOpen(false);
  //     onFilter({
  //       from: range.from,
  //       to: range.to,
  //     });
  //   }
  // };

  // const handleClickReset = () => {
  //   setPickerOpen(false);
  //   onFilter({
  //     from: undefined,
  //     to: undefined,
  //   });
  //   setState({
  //     from: undefined,
  //     to: undefined,
  //   });
  // };

  return (
    <VirtualTable.Cell
      {...restProps}
      style={{
        justifyContent: 'flex-end',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      {!restProps.column.isDate && (
        <Input
          className="general-list-filter-cell"
          name={restProps.column.name}
          id={restProps.column.name}
          type="text"
          value={filter ? filter.value : ''}
          placeholder={restProps.column.placeholder || 'Filtro'}
          onChange={e => onFilter(e.target.value ? { value: e.target.value } : null)}
        />
      )}
      {/* {restProps.column.isDate && !restProps.column.isRange && (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <DatePicker
            value={currentDate}
            onChange={d => changeDateFilter(d)}
            format="dd 'de' MMMM"
          />
        </MuiPickersUtilsProvider>
      )} */}
      {/* {restProps.column.isDate && restProps.column.isRange && (
        <>
          <Input
            placeholder={restProps.column.placeholder || 'Filtro'}
            value={
              from && to ? `${moment(from).format('LL')} - ${moment(to).format('LL')}` : ''
            }
            onClick={() => setPickerOpen(!pickerOpen)}
            classes={{
              ...classes,
              root: classes.root,
              underline: classes.underline,
            }}
            InputProps={{
              classes: {
                root: classes.root,
              },
            }}
          />
          {pickerOpen && (
            <PickerContainer float={restProps.column.startOfPicker}>
              <DayPicker
                placeholder="Seleccione la fecha"
                className="Selectable"
                numberOfMonths={2}
                selectedDays={{ from, to }}
                modifiers={modifiers}
                onDayClick={handleDayClick}
              />
              <Reset onClick={handleClickReset}>Reiniciar</Reset>
            </PickerContainer>
          )}
          {pickerOpen && <ClosePickerDiv onClick={() => setPickerOpen(false)} />}
        </>
      )} */}
    </VirtualTable.Cell>
  );
};

FilterCell.propTypes = {
  filter: PropTypes.any,
  onFilter: PropTypes.func,
  isDate: PropTypes.bool,
};

export default FilterCell;
